define('plugin/promotion/view/PromotionItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings','Config','lib/plugin/PluginBroker'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ThemeSettings = require('lib/theme/ThemeSettings');
    var Config = require('Config');

    var PluginBroker = require('lib/plugin/PluginBroker');
    /**
     * Promotion info view (promotion item)
     *
     * @class PromotionItemView
     */
    return LayoutView.extend({
        _clientModel: null,

        initialize: function () {
            LayoutView.prototype.initialize.apply(this);

            if (Config.getInstance().getPluginStatus('client_login')) {
                var clientPlugin = PluginBroker.getInstance().getPlugin('client_login');
                this._clientModel = clientPlugin.getClientModel();
            }
        },

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#promotion_item_view_list';
            }
            return '#promotion_item_view';
        },


        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);

            var data = {};
            if (Config.getInstance().getPluginStatus('bonus_system')) {
                if (result['bonus_is_enabled'] && this._clientModel && !_.isUndefined(this._clientModel.get('bonus_balance'))) {
                    data['bonus_balance'] = this._clientModel.get('bonus_balance');
                    data['bonus_available'] = (data['bonus_balance'] - result['bonus_amount']) >= 0;
                }
            }
            return _.extend(data, result);
        },

    });

});
